import Error from "../pages/error";

import { lazy } from "react";

import EditCuriorsPage from "../pages/curiors/edit";
import CuriorShowPage from "../pages/curiors/show";
import CuriorStorePage from "../pages/curiors/store";
import FinancialManagement from "../pages/financialManagement";
import MarktingPage from "../pages/markting";
import OrdersPage from "../pages/orders";
import OrderShowPage from "../pages/orders/show";
import ShippingPage from "../pages/shipping";
import EditCompanyDelivery from "../pages/shipping/edit";
import ShippingShowPage from "../pages/shipping/show";
import ShippingStorePage from "../pages/shipping/store";
import ShippingPricingStore from "../pages/shippingPricing/store";
import StoresPage from "../pages/stores/stores";
import StoreEditPage from "../pages/stores/edit";
import EditProductPage from "../pages/stores/product/edit";
import ProductIndex from "../pages/stores/product/index";
import ProductShowPage from "../pages/stores/product/show";
import ProductStorePage from "../pages/stores/product/store";
import StoreShowPage from "../pages/stores/show";
import StoresStorePage from "../pages/stores/store";
import SystemSettingsPage from "../pages/systemsettings";
import UsersPage from "../pages/users";
import UserShowPage from "../pages/users/show";
import ShippingPricingEdit from "../pages/shippingPricing/edit";
import RewardsPage from "../pages/rewards";
import ChooseStore from "../pages/chooseStore";
import TechnicalSupportPage from "../pages/technicalSupport";
import ReportsPage from "../pages/reports";
import DownloadsPage from "../pages/downloads";
import VendorsPage from "../pages/stores/vendors";
import PosPage from "../pages/stores/pos";
import ShippingCompaniesPage from "../pages/shipping/shippingCompanies";
import DriversPage from "../pages/shipping/drivers";
import AreaPricingPage from "../pages/shipping/areaPricing";
import PaymentMethodsPage from "../pages/financialManagement/paymentMethods";
import PaymentRecordsPage from "../pages/financialManagement/paymentRecord";
import PaymentRequestsPage from "../pages/financialManagement/paymentRequests";
import CommissionSettingsPage from "../pages/financialManagement/commissionSettings";
import CustomerReportPage from "../pages/reports/customerReport";
import DeliveryReportPage from "../pages/reports/deliveryReport";
import OrdersReportPage from "../pages/reports/orderReport";
import SalesReportPage from "../pages/reports/salesReport";
import StoresReportPage from "../pages/reports/storesReport";
import BannersPage from "../pages/markting/banners";
import CouponsPage from "../pages/markting/coupons";
import PromotionsPage from "../pages/markting/promotions";
import QuickOffersPage from "../pages/markting/quickOffers";
import SlidersPage from "../pages/markting/sliders";
import SpecialOffersPage from "../pages/markting/specialOffers";
import PointsPage from "../pages/rewards/points";
import OrderAmountPage from "../pages/rewards/ordersAmount";
import ExchangePage from "../pages/rewards/exchange";
import ReviewsPage from "../pages/technicalSupport/reviews";
import SupportPage from "../pages/technicalSupport/supportClient";
import AdminsPage from "../pages/roles/admins";
import RolesPage from "../pages/roles/roles";
import CategoriesPage from "../pages/categories/categories";
import SectionsPage from "../pages/categories/sections";
import ZonesPage from "../pages/places/zones";
import GovernoratesPage from "../pages/places/governorates";
import CountriesPage from "../pages/places/countries";
import CitiesPage from "../pages/places/cities";
import RatingsPage from "../pages/ratings";
import LoyaltyPage from "../pages/loyalty";
import NotificationsPage from "../pages/notifications";
import TermsPage from "../pages/terms";
import LanguagePage from "../pages/language";
import VehiclesPage from "../pages/vehicles";
import WorkingHours from "../pages/workingHours";
import UserEditPage from "../pages/users/edit";
import ComplaintsPage from "../pages/contactUs";

const Home = lazy(() => import("../pages/home"));

export const routes = [
  { path: `${process.env.PUBLIC_URL}/home`, Component: <Home /> },


  { path: `${process.env.PUBLIC_URL}/store/:id`, Component: <StoreShowPage /> },
  {
    path: `${process.env.PUBLIC_URL}/orders/:id`,
    Component: <OrderShowPage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/product/:id`,
    Component: <ProductShowPage />,
  },

  // {
  //   path: `${process.env.PUBLIC_URL}/technical-support`,
  //   Component: <TechnicalSupportPage />,   
  // },

  // {
  //   path: `${process.env.PUBLIC_URL}/marking`,
  //   Component: <MarktingPage />,
  // },
  {
    path: `${process.env.PUBLIC_URL}/shipping/store-curior`,
    Component: <CuriorStorePage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/shipping/store-shippings`,
    Component: <ShippingStorePage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/shipping/store-pricing-zone`,
    Component: <ShippingPricingStore />,
  },
  {
    path: `${process.env.PUBLIC_URL}/shipping/store-pricing-zone/edit/:id`,
    Component: <ShippingPricingEdit />,
  },
  // { path: `${process.env.PUBLIC_URL}/shipping`, Component: <ShippingPage /> },
  { path: `${process.env.PUBLIC_URL}/user/:id`, Component: <UserShowPage /> },
  { path: `${process.env.PUBLIC_URL}/orders`, Component: <OrdersPage /> },
  { path: `${process.env.PUBLIC_URL}/products`, Component: <ProductIndex /> },
  // {
  //   path: `${process.env.PUBLIC_URL}/system-settings`,
  //   Component: <SystemSettingsPage />,
  // },
  {
    path: `${process.env.PUBLIC_URL}/users`,
    Component: <UsersPage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/users/edit/:id`,
    Component: <UserEditPage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/stores/store`,
    Component: <StoresStorePage />,
  },
  //   {
  //   path: `${process.env.PUBLIC_URL}/reports-analytics`,  
  //   Component: <ReportsPage />,
  // },
  {
    path: `${process.env.PUBLIC_URL}/curior/:id`,
    Component: <CuriorShowPage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/curior/edit/:id`,
    Component: <EditCuriorsPage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/shipping/:id`,
    Component: <ShippingShowPage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/shipping/edit/:id`,
    Component: <EditCompanyDelivery />,
  },
  {
    path: `${process.env.PUBLIC_URL}/products/store`,
    Component: <ProductStorePage />,
  },

    {
    path: `${process.env.PUBLIC_URL}/vendor/choose-store`,
    Component: <ChooseStore/>,
  },
      {
    path: `${process.env.PUBLIC_URL}/downloads`,
    Component: <DownloadsPage/>,
  },
  // {
  //   path: `${process.env.PUBLIC_URL}/rewards`,
  //   Component: <RewardsPage />,
  // },
  {
    path: `${process.env.PUBLIC_URL}/product/edit/:id`,
    Component: <EditProductPage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/stores/edit/:id`,
    Component: <StoreEditPage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/stores/product/store`,
    Component: <StoresStorePage />,
  },

  {
    path: `${process.env.PUBLIC_URL}/stores/product/store`,
    Component: <StoresStorePage />,
  },
  // {
  //   path: `${process.env.PUBLIC_URL}/financial-management`,
  //   Component: <FinancialManagement />,
  // },

  { path: "*", Component: <Error /> },
  
  // stores subitems
  { path: `${process.env.PUBLIC_URL}/vendors`, Component: <VendorsPage /> },
  { path: `${process.env.PUBLIC_URL}/stores`, Component: <StoresPage /> },
  { path: `${process.env.PUBLIC_URL}/pos`, Component: <PosPage /> },

  // shipping subitems
  { path: `${process.env.PUBLIC_URL}/shipping-companies`, Component: <ShippingCompaniesPage /> },
  { path: `${process.env.PUBLIC_URL}/drivers`, Component: <DriversPage /> },
  { path: `${process.env.PUBLIC_URL}/area-pricing`, Component: <AreaPricingPage /> },
  
  // Financial Management subitems
  { path: `${process.env.PUBLIC_URL}/payment-methods`, Component: <PaymentMethodsPage /> },
  { path: `${process.env.PUBLIC_URL}/payment-record`, Component: <PaymentRecordsPage /> },
  { path: `${process.env.PUBLIC_URL}/payment-requests`, Component: <PaymentRequestsPage /> },
  { path: `${process.env.PUBLIC_URL}/commission-settings`, Component: <CommissionSettingsPage /> },

  // reports analytics subitems
  { path: `${process.env.PUBLIC_URL}/customer-report`, Component: <CustomerReportPage /> },
  { path: `${process.env.PUBLIC_URL}/delivery-report`, Component: <DeliveryReportPage /> },
  { path: `${process.env.PUBLIC_URL}/orders-report`, Component: <OrdersReportPage /> },
  { path: `${process.env.PUBLIC_URL}/sales-report`, Component: <SalesReportPage /> },
  { path: `${process.env.PUBLIC_URL}/stores-report`, Component: <StoresReportPage /> },
  
  // marketing subitems
  { path: `${process.env.PUBLIC_URL}/banners`, Component: <BannersPage /> },
  { path: `${process.env.PUBLIC_URL}/coupons`, Component: <CouponsPage /> },
  { path: `${process.env.PUBLIC_URL}/promotions`, Component: <PromotionsPage /> },
  { path: `${process.env.PUBLIC_URL}/quick-offers`, Component: <QuickOffersPage /> },
  { path: `${process.env.PUBLIC_URL}/sliders`, Component: <SlidersPage /> },
  { path: `${process.env.PUBLIC_URL}/special-offers`, Component: <SpecialOffersPage /> },

  // rewards subitems
  { path: `${process.env.PUBLIC_URL}/points`, Component: <PointsPage /> },
  { path: `${process.env.PUBLIC_URL}/order-amount`, Component: <OrderAmountPage /> },
  { path: `${process.env.PUBLIC_URL}/exchange-points`, Component: <ExchangePage /> },
  
  // technical support subitems
  { path: `${process.env.PUBLIC_URL}/reviews`, Component: <ReviewsPage /> },
  { path: `${process.env.PUBLIC_URL}/support`, Component: <SupportPage /> },

  // roles subItems
  { path: `${process.env.PUBLIC_URL}/roles`, Component: <RolesPage /> },
  { path: `${process.env.PUBLIC_URL}/admins`, Component: <AdminsPage /> },
  
  // categories subItems
  { path: `${process.env.PUBLIC_URL}/categories`, Component: <CategoriesPage /> },
  { path: `${process.env.PUBLIC_URL}/sections`, Component: <SectionsPage /> },
  
  // places subItems
  { path: `${process.env.PUBLIC_URL}/countries`, Component: <CountriesPage /> },
  { path: `${process.env.PUBLIC_URL}/governorates`, Component: <GovernoratesPage /> },
  { path: `${process.env.PUBLIC_URL}/cities`, Component: <CitiesPage /> },
  { path: `${process.env.PUBLIC_URL}/zones`, Component: <ZonesPage /> },
  
  { path: `${process.env.PUBLIC_URL}/vehicles`, Component: <VehiclesPage /> },
  { path: `${process.env.PUBLIC_URL}/ratings`, Component: <RatingsPage /> },
  { path: `${process.env.PUBLIC_URL}/loyalty`, Component: <LoyaltyPage /> },
  { path: `${process.env.PUBLIC_URL}/terms`, Component: <TermsPage /> },
  { path: `${process.env.PUBLIC_URL}/notifications`, Component: <NotificationsPage /> },
  { path: `${process.env.PUBLIC_URL}/language`, Component: <LanguagePage /> },

  // working hours
  {
    path: `${process.env.PUBLIC_URL}/working-hours`,
    Component: <WorkingHours />,
  },

  // complaints
  {
    path: `${process.env.PUBLIC_URL}/complaints`,
    Component: <ComplaintsPage />,
  },

];
